<as-split class="listing" direction="horizontal" [gutterSize]="18">
  <as-split-area [size]="30">
    <div class="tree-node" (click)="addNewCategory()">
      <button mat-icon-button>
        <mat-icon svgIcon="plus"></mat-icon>
      </button>
      <span class="name">New category</span>
    </div>

    <div class="dataset-listing-tree">
      <mood-category-tree-node *ngFor="let node of categoryTreeList" [node]="node"></mood-category-tree-node>
    </div>
  </as-split-area>

  <as-split-area [size]="70">
    <ng-container *ngIf="selectedCategory">
      <mood-category-edit-form [category]="selectedCategory"></mood-category-edit-form>
    </ng-container>
  </as-split-area>
</as-split>
